import * as moment from 'moment';

export class UserToken {
    issued: moment.Moment;
    expires: moment.Moment;
    token: string;
    tenant: string;
    accountName: string;

    constructor(info: any) {
        this.issued = moment(info['.issued']);
        this.expires = moment(info['.expires']);
        this.token = info['access_token'];
        this.tenant = info['clientId'];
        this.accountName = info['accountName'];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/user-token.ts